import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const locationInfo = {
  'aisle': '',
  'module': '',
  'level': '',
  'sequential': '',
  'binType': '',
  'warehouses': [],
  'pickingZone': '',
};

const INITIAL_STATE = {
  'loading': false,
  'loadingFile': false,
  'locations': [locationInfo],
  'locationsToPrint': [],
};

const removeLocation = (state, index) => {
  const newLocations = [...state.locations];
  newLocations.splice(index, 1);
  
  return newLocations;
};

const updateSelectedLocation = (locations, payload) => {
  const newLocations = [...locations];
  const selectedLocation = {...newLocations[payload.index]};
  selectedLocation[payload.field] = payload.value;
  newLocations.splice(payload.index, 1, selectedLocation);

  return newLocations;
};

const updateWarehouses = (locations, payload) => {
  const newLocations = [...locations];
  const selectedLocation = {...newLocations[payload.index]};
  const warehouses = [...selectedLocation.warehouses];

  if (warehouses.indexOf(payload.warehouse) !== -1) {
    selectedLocation.warehouses = warehouses.filter((item) => item !== payload.warehouse);
  } else {
    warehouses.push(payload.warehouse);
    selectedLocation.warehouses = warehouses;
  }

  newLocations.splice(payload.index, 1, selectedLocation);
  return newLocations;
};

export const warehouseLocation = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CREATING_WAREHOUSE_LOCATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WAREHOUSE_LOCATION]: (state, action) => ({
      ...state,
      'locations': [locationInfo],
      'locationsToPrint': action.response.data,
      'loading': false,
    }),
    [ActionTypes.CREATED_WAREHOUSE_LOCATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAR_LOCATIONS_TO_PRINT]: (state, action) => ({
      ...state,
      'locationsToPrint': [],
    }),
    [ActionTypes.CLEAR_LOCATIONS]: (state, action) => ({
      ...state,
      'locations': [],
    }),
    [ActionTypes.ADD_WAREHOUSE_LOCATION]: (state, action) => ({
      ...state,
      'locations': [...state.locations, locationInfo],
    }),
    [ActionTypes.REMOVE_WAREHOUSE_LOCATION]: (state, action) => ({
      ...state,
      'locations': removeLocation(state, action.payload),
    }),
    [ActionTypes.LOAD_WAREHOUSE_LOCATIONS_FILE]: (state, action) => ({
      ...state,
      'locations': action.payload,
    }),
    [ActionTypes.CHANGE_SELECTED_LOCATION_VALUE]: (state, action) => ({
      ...state,
      'locations': updateSelectedLocation(state.locations, action.payload),
    }),
    [ActionTypes.CHANGE_SELECTED_LOCATION_WAREHOUSES]: (state, action) => ({
      ...state,
      'locations': updateWarehouses(state.locations, action.payload),
    }),
    [ActionTypes.CHANGE_LOCATION_FILE_LOADING_STATUS]: (state, action) => ({
      ...state,
      'loadingFile': action.payload,
    }),
  })(state, action);
};
